var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddImage = function SvgAddImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.506 14.167q-.63 0-1.068-.438A1.45 1.45 0 0 1 0 12.66V1.506Q0 .876.438.438A1.45 1.45 0 0 1 1.506 0h6.25v1.25h-6.25a.25.25 0 0 0-.184.072.25.25 0 0 0-.072.184V12.66a.25.25 0 0 0 .072.185.25.25 0 0 0 .184.072H12.66a.25.25 0 0 0 .185-.072.25.25 0 0 0 .072-.185V6.41h1.25v6.25q0 .631-.438 1.07a1.46 1.46 0 0 1-1.069.437zm.898-3.174h9.359L8.854 7.115l-2.5 3.246-1.77-2.252zm8.846-6.41V2.917H9.583v-1.25h1.667V0h1.25v1.667h1.667v1.25H12.5v1.666z"
  })));
};
export default SvgAddImage;